module.exports = __webpack_public_path__ + "static/media/selected.c8b93c6c.svg";